import { AppShell, Group } from '@mantine/core';

import { PRODUCT_NAME } from '../../../brand';
import { CLEAR_OF_AGENT_PANEL } from '../../agent/agentPanel';

type LayoutFooterProps = {
  isMobile: boolean;
};

export function LayoutFooter({ isMobile }: LayoutFooterProps) {
  // Collapsing moves the footer with a transform rather than removing it,
  // so on a phone the landmark is still in the accessibility tree with
  // nothing in it. Its links already moved to the drawer.
  return (
    <AppShell.Footer
      aria-hidden={isMobile}
      data-testid="layout-footer"
      style={{
        ...CLEAR_OF_AGENT_PANEL,
        borderLeft: '100px solid var(--mantine-color-orange-6)',
        borderRight: '5px solid var(--mantine-color-orange-6)',
      }}
    >
      <div
        style={{
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          paddingRight: '16px',
          paddingBottom: '6px',
          paddingTop: '6px',
          position: 'relative',
        }}
      >
        {/* Collapsing a footer moves it with a transform, it does not remove
            it. Left rendered on a phone these links stay focusable off-screen
            and give the page a second Privacy Policy for any name-based
            query, alongside the copies now in the drawer. */}
        {!isMobile && (
          <div style={{ display: 'flex', gap: '10px', position: 'relative', zIndex: 1 }}>
            <Group justify="space-between" align="center">
              <a
                href="/privacy-policy"
                style={{ textDecoration: 'none', color: 'inherit', fontSize: '14px' }}
              >
                Privacy Policy
              </a>
              <a
                href="/terms-of-use"
                style={{ textDecoration: 'none', color: 'inherit', fontSize: '14px' }}
              >
                Terms of Service
              </a>
              <img
                src="/logos/teoai-logo-dark.png"
                alt={PRODUCT_NAME}
                style={{
                  height: '20px',
                }}
              />
            </Group>
          </div>
        )}
      </div>
    </AppShell.Footer>
  );
}
